<template>
    <v-dialog scrollable v-model="showProfileSummaryEditDialog" v-if="showProfileSummaryEditDialog" content-class="medium">
        <v-card class="myprofile-popup">
            <v-card-title primary-title>
                {{memberProfileConstants.SUMMARY.EDIT_PROFILE_SUMMARY}}  
                <i class="fas fa-times" data-qe-id="closeProfileSummaryEditDialog" @click="closeProfileSummaryEdit()"></i>
            </v-card-title>
            <v-card-text class="inner-scrollbar">
                <v-form lazy-validation ref="editProfileSummaryForm" v-model="valid">
                    <v-layout row wrap>
                        <v-flex xs12 sm6>
                            <v-flex class="form-control">
                                <span class="select-label">{{memberProfileConstants.SUMMARY.PREFERRED_NAME}}</span>
                                <v-text-field 
                                color="ypo_blue" 
                                data-qe-id="preferredName"
                                v-model="userProfile.preferredName"
                                :placeholder="memberProfileConstants.SUMMARY.PREFERRED_NAME"
                                :maxlength="memberProfileConstants.MYCOMMUNITIES_NETWORK_NAME_MAX_TEXT_LENGTH"></v-text-field>
                            </v-flex>
                        </v-flex>
                        <v-flex xs12 sm6>
                            <v-flex class="form-control">
                                <span class="select-label">{{memberProfileConstants.SUMMARY.PREFIX}}</span>
                                <span class="required-label">{{memberProfileConstants.REQUIRED}}</span>
                                <v-autocomplete
                                    attach
                                    height="32"
                                    color="ypo_blue"
                                    data-qe-id="userPrefix"
                                    :items="allPrefixes"
                                    item-text="prefix"
                                    v-model="userProfile.prefix"
                                    :placeholder="memberProfileConstants.SUMMARY.PREFIX">
                                </v-autocomplete>
                            </v-flex>   
                        </v-flex>
                    </v-layout>
                    <v-layout row wrap>
                        <v-flex xs12 sm6>
                            <v-flex class="form-control">
                                <span class="select-label">{{memberProfileConstants.SUMMARY.FIRST_NAME}}{{memberProfileConstants.ASTERISK}}</span>
                                <v-text-field 
                                color="ypo_blue"
                                height="32"
                                data-qe-id="userFirstName"
                                v-model="userProfile.firstName"
                                :placeholder="memberProfileConstants.FIRST_NAME"
                                :rules="memberProfileConstants.SUMMARY.FIRSTNAME_RULE"
                                required
                                :maxlength="memberProfileConstants.MYCOMMUNITIES_NETWORK_NAME_MAX_TEXT_LENGTH"></v-text-field>
                            </v-flex>
                        </v-flex>
                        <v-flex xs12 sm6>
                            <v-flex class="form-control">
                                <span class="select-label">{{memberProfileConstants.MIDDLE_NAME}}</span>
                                <v-text-field 
                                color="ypo_blue"
                                height="32"
                                data-qe-id="userMiddleName" 
                                v-model="userProfile.middleName"
                                :placeholder="memberProfileConstants.MIDDLE_NAME"
                                :maxlength="memberProfileConstants.MYCOMMUNITIES_NETWORK_NAME_MAX_TEXT_LENGTH"></v-text-field>
                            </v-flex>
                        </v-flex>
                    </v-layout>
                    <v-layout row wrap>
                        <v-flex xs12 sm6>
                            <v-flex class="form-control">
                                <span class="select-label">{{memberProfileConstants.FAMILY_NAME}}{{memberProfileConstants.ASTERISK}}</span>
                                <v-text-field 
                                color="ypo_blue"
                                data-qe-id="userFamilyName"
                                v-model="userProfile.lastName"
                                :placeholder="memberProfileConstants.FAMILY_NAME"
                                :rules="memberProfileConstants.SUMMARY.LASTNAME_RULE"
                                required
                                :maxlength="memberProfileConstants.MYCOMMUNITIES_NETWORK_NAME_MAX_TEXT_LENGTH"></v-text-field>
                            </v-flex>
                        </v-flex>
                        <v-flex xs12 sm6>
                            <v-flex class="form-control">
                                <span class="select-label">{{memberProfileConstants.SUMMARY.SUFFIX}}</span>
                                <v-autocomplete
                                    attach
                                    height="32"
                                    color="ypo_blue"
                                    data-qe-id="userSuffix"
                                    :items="allSuffixes"
                                    item-text="suffix"
                                    v-model="userProfile.suffix"
                                    :placeholder="memberProfileConstants.SUMMARY.SUFFIX">
                                </v-autocomplete>
                            </v-flex>
                        </v-flex>
                    </v-layout>
                    <v-layout row wrap>
                        <v-flex xs12 sm6>
                            <v-flex class="form-control">
                                <span class="select-label">{{memberProfileConstants.SUMMARY.BIRTHDAY}}</span>
                                <v-text-field 
                                color="ypo_blue" 
                                data-qe-id="userBirthdate"
                                v-model="dateOfBirth"
                                :disabled="true"></v-text-field>
                            </v-flex>
                        </v-flex>
                        <v-flex xs12 sm6>
                            <v-flex class="form-control">
                                <span class="select-label">{{memberProfileConstants.SUMMARY.AGE}}</span>
                                <v-text-field
                                    height="32"
                                    color="ypo_blue"
                                    data-qe-id="userAge"
                                    :value="getAge()"
                                    :disabled="true">
                                </v-text-field>
                            </v-flex>
                        </v-flex>
                    </v-layout>
                </v-form>
            </v-card-text>
            <status-bar :action="saveProfileSummaryAction"></status-bar>
            <v-card-actions>
                <v-flex text-xs-right pa-3>
                    <v-btn flat class="primary_btn transparent" data-qe-id="editProfileSummary_cancelBtn" @click="closeProfileSummaryEdit()">
                        {{appCommonConstants.CANCEL}}
                    </v-btn>
                    <v-btn class="primary_btn" data-qe-id="editProfileSummary_saveBtn" @click="saveProfileSummary()" :disabled="!valid || isSaveInProgress">
                        {{appCommonConstants.DONE}}
                    </v-btn>
                </v-flex>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
    import { memberProfileConstants } from "../memberProfile.constants.js";
    import { appCommonConstants } from "../../appCommon.constants.js";
    import { getFormattedDateMonthYear, calculateAge } from "@/common/utils/dateTime";
    import { mapActions, mapGetters, mapState } from "vuex";
    import { storeAction } from "../../../store/storeActions.constant";
    import { storeGetters } from "../../../store/storeGetters.constant";
    import StatusBar from "../../StatusBar/StatusBar";
    import Vue from 'vue';

    export default {
        data: () => ({
            appCommonConstants,
            memberProfileConstants,
            calculateAge,
            isSaveInProgress: false,
            valid: true,
        }),
        components: {
            StatusBar,
        },
        props: {
            value: {
                type: Boolean,
            },
            memberId: {
                type: String,
                required: true,
            },
        },
        methods: {
            ...mapActions({
                saveProfileSummaryDetails: `memberProfile/${storeAction.saveProfileSummaryDetails}`,
                getProfileInformation: `myAccount/${storeAction.getProfileInformation}`,
            }),
            saveProfileSummary() {
                const ref = this.$refs.editProfileSummaryForm;
                if (ref && ref.validate && ref.validate()) {
                    this.isSaveInProgress = true;
                    this.userProfile.Id = this.memberId;
                    this.saveProfileSummaryDetails(this.userProfile)
                    .then(() => {
                        this.isSaveInProgress = false;
                        this.closeProfileSummaryEdit();
                        if (this.isCurrentUser) {
                            this.getProfileInformation(this.memberId);
                        }
                    }).catch(() => {
                        this.isSaveInProgress = false;
                    });
                } else {
                    this.valid = false;
                }
            },
            getAge() {
                return this.userProfile.age || this.calculateAge(this.userProfile.birthDate);
            },
            closeProfileSummaryEdit() {
                this.showProfileSummaryEditDialog = false;
            },
        },
        computed: {
            ...mapGetters({
                allPrefixes: `memberProfile/${storeGetters.allPrefixes}`,
                allSuffixes: `memberProfile/${storeGetters.allSuffixes}`,
                userProfileInfo: `memberProfile/${storeGetters.userProfile}`,
                currentUserId: `memberProfile/${storeGetters.currentUserId}`,
            }),
            ...mapState("actionState", ["actions"]),
            showProfileSummaryEditDialog: {
                get() {
                    return this.value;
                },
                set(value) {
                    this.$emit('input', value);
                },
            },
            userProfile() {
                if (this.userProfileInfo !== "") {
                    return Vue.util.extend({}, this.userProfileInfo);
                }
                return [];  
            },
            dateOfBirth() {
                if (this.userProfile !== "" && this.userProfile.birthDate !== null) {
                    return getFormattedDateMonthYear(this.userProfile.birthDate);
                }
                return "";
            },
            saveProfileSummaryAction() {
                return this.actions[storeAction.saveProfileSummaryDetails];
            },
            isCurrentUser() {
                return this.memberId === this.currentUserId;
            },
        },
    };
</script>

<style lang="scss" scoped>
    
    .required-label {
        float: right;
    }
</style>
